import ContentStyleEdition from "./ContentStyleEdition";

export default ContentStyleEdition;
